/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/media-has-caption */
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import intl from 'react-intl-universal';
import { AppConsumer } from '../../context/AppContext';
import { isCNMode } from '../../utils/helpers';
// const bg_video = require('../../assets/about-us/bg-all.mp4');
// import bgtime from '../../assets/about-us/bg-time.png';
import './PCAbout-us.scss';
import { useHashScroll, VoiceContext } from '../../utils/effects';
import { LazyComponent } from '../../utils/decorators';
import timeLineImg from '../../assets/about-us/about-us-timeline.png';
import { VideoVoiceButton } from '../../components/Video';

function Video() {
  return (
    <video loop muted autoPlay id="kuaishou-video">
      <source
        src="https://static.yximgs.com/udata/pkg/EE-PA-PUBLIC/english-website/home-video.v1.mp4"
        type="video/mp4"
      />
      Sorry, your browser does not support embedded video.
    </video>
  );
}

const aboutBanner = () => {
  // const ref = useRef<HTMLVideoElement | null>(null);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // 自适应浏览器的高度
  const handleSize = () => {
    if (window.innerHeight > 900) {
      setWindowHeight(window.innerHeight);
    } else {
      setWindowHeight(900);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleSize);
    return () => {
      window.removeEventListener('resize', handleSize);
    };
  }, []);

  return (
    <div style={{ height: windowHeight, position: 'relative' }}>
      <div className="video-wrap">{Video()}</div>
      <div className="banner-content">
        <h1>{intl.get('about-us.banner.title')}</h1>
        <p>{intl.get('about-us.banner.p1')}</p>
      </div>
    </div>
  );
};

const PCAboutUs = () => {
const data = useRef<HTMLDivElement | null>(null);
useHashScroll();
  useEffect(() => {
    if(data.current) {
      data.current.scrollLeft = data.current?.scrollWidth || 0;
    }
  }, []);
  return (
    <div className="about-us">
      {aboutBanner()}
      <div className="about-us-company-overview">
        <div id="company-overview" className="company-wrap">
          {LazyComponent(500, <div className="building" />)}
          <div className="company-overview-content">
            <h1>{intl.get('about-us.company-overview.title')}</h1>
            <div className="decoration-border" />
            <p>{intl.get('about-us.company-overview.p1')}</p>
            <p>{intl.get('about-us.company-overview.p2')}</p>
          </div>
        </div>
      </div>
      <div id="culture" className="about-us-culture-and-values">
        <div className="culture-and-values-wrap">
          <div className="culture-and-values-content">
            <h1>{intl.get('about-us.culture-and-values.title')}</h1>
            <div className="decoration-border" />
            <p>{intl.get('about-us.culture-and-values.p1')}</p>
            <p>{intl.get('about-us.culture-and-values.p2')}</p>
          </div>
          {LazyComponent(500, <div className="culture" />)}
        </div>
      </div>
      <div id="leadership" className="about-us-leadership">
        <div className="leadership-wrap">
          {LazyComponent(500, <div className="leader" />)}
          <div className="leadership-content">
            <h1>{intl.get('about-us.leadership.title')}</h1>
            <div className="decoration-border" />
            <span className="suhua">
              <div className="leader-name">Su Hua</div>
              <p>{intl.get('about-us.leadership.su-hua')}</p>
            </span>
            <span className="chengyixiao">
              <div className="leader-name">Cheng Yixiao</div>
              <p>{intl.get('about-us.leadership.cheng-yixiao')}</p>
              <p>{intl.get('about-us.leadership.cheng-yixiao-second')}</p>
            </span>
          </div>
        </div>
      </div>
      <div id="milestones" className="about-us-milestones">
        {LazyComponent(
          500,
          <div className="milestones-logo">
            <div className="milestones-content">
              <h1>{intl.get('about-us.milestones.title')}</h1>
              <div className="decoration-border" />
            </div>
          </div>
        )}
        {/* <div className="context-top"> */}
        {/*  <div className="p2011">{intl.get("about-us.milestones.p2011")}</div> */}
        {/*  <div className="p2013">{intl.get("about-us.milestones.p2013")}</div> */}
        {/*  <div className="p2017">{intl.get("about-us.milestones.p2017")}</div> */}
        {/*  <div className="p2019"> */}
        {/*    <ul> */}
        {/*      <li> */}
        {/*        <div className="marker" /> */}
        {/*        {intl.get("about-us.milestones.p2019-1")} */}
        {/*      </li> */}
        {/*      <li> */}
        {/*        <div className="marker" /> */}
        {/*        {intl.get("about-us.milestones.p2019-2")} */}
        {/*      </li> */}
        {/*    </ul> */}
        {/*  </div> */}
        {/*  <div className="p2021"> */}
        {/*    {intl.get("about-us.milestones.p2021")} */}
        {/*  </div> */}
        {/* </div> */}
        <div className="img-time">
          <div className="about-us-timeline" id='time-line' ref={data}>
              <img className="img-time-img" src={timeLineImg} alt="" />
          </div>
          {/* <div className="gray-border" /> */}
        </div>
        {/* <div className="context-bottom"> */}
        {/*  <div className="p2012">{intl.get("about-us.milestones.p2012")}</div> */}
        {/*  <div className="p2016">{intl.get("about-us.milestones.p2016")}</div> */}
        {/*  <div className="p2018"> */}
        {/*    <ul> */}
        {/*      <li> */}
        {/*        <div className="marker" /> */}
        {/*        {intl.get("about-us.milestones.p2018-1")} */}
        {/*      </li> */}
        {/*      <li> */}
        {/*        <div className="marker" /> */}
        {/*        {intl.get("about-us.milestones.p2018-2")} */}
        {/*      </li> */}
        {/*    </ul> */}
        {/*  </div> */}
        {/*  <div className="p2020"> */}
        {/*    <ul> */}
        {/*      <li> */}
        {/*        <div className="marker" /> */}
        {/*        {intl.get("about-us.milestones.p2020-1")} */}
        {/*      </li> */}
        {/*      <li> */}
        {/*        <div className="marker" /> */}
        {/*        {intl.get("about-us.milestones.p2020-2")} */}
        {/*      </li> */}
        {/*    </ul> */}
        {/*  </div> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default AppConsumer(PCAboutUs);
